<template>
	<popup v-model="show" :isShowMask="false">
		<div class="v5-checklist-selected-wrap">
			<div class="v5-checklist-selected">
				<span class="v5-checklist-selected-title">已选</span>
				<div class="v5-checklist-selected-scroller-wrap">
					<scroller :scrollingX="true" :scrollingY="false" :positionX="positionX">
						<div class="v5-checklist-selected-list">
							<a href="javascript:;" class="v5-checklist-selected-item" v-for="item in currentValue" :key="item.id" @click="remove(item.id)">
								{{item.name}}
								<i class="v5-checklist-selected-item-close"></i>
							</a>
						</div>
					</scroller>
				</div>

			</div>
			<a href="javascript:void(0);" class="v5-checklist-selected-btn" @click="confirm">确认 {{selLength}}/{{max}}</a>
		</div>
	</popup>
</template>
<script>
	import Popup from './../../popup';
	import Scroller from './../../scroller';
	export default {
		props: {
			value: {
				type: Boolean,
				default: false
			},
			selects: {
				type: Array,
				default: () => []
			},
			max: {
				type: Number,
				default: 5
			}
		},
		components: {
			Popup,
			Scroller
		},
		computed: {
			selLength() {
				return this.currentValue.length;
			}
		},
		watch: {
			value(val) {
				this.show = val;
			},
			selects(val) {
				this.currentValue = val;
			},
			selLength(val) {
				this.setPosition();
			}
		},
		methods: {
			confirm() {
				this.$emit('confirm', this.currentValue);
			},
			//删除
			remove(id) {
				let index = this.findIndex(this.currentValue, id);
				this.currentValue.splice(index, 1);
				this.$emit('update', this.currentValue);
			},
			//查找下标
			findIndex(arr, id) {
				let index = arr.findIndex(item => {
					return item.id === id;
				});
				return index;
			},
			//设置位置
			setPosition() {
				this.$nextTick(() => {
					let srollerWrapWidth = this.$el.getElementsByClassName(
						'v5-checklist-selected-scroller-wrap'
					)[0].offsetWidth;
					let srollerWidth = this.$el.getElementsByClassName(
						'v5-checklist-selected-list'
					)[0].offsetWidth;
					if (srollerWidth > srollerWrapWidth) {
						this.positionX = srollerWidth - srollerWrapWidth;
					}
				});
			},
			//设置底部已选择列表宽
			setSelListDomWidth() {
				let selListDom = this.$el.getElementsByClassName(
						'v5-checklist-selected-list'
					)[0],
					selListDomWidth = 60,
					selListChilds = selListDom.children;

				for (let i = 0, l = selListChilds.length; i < l; i++) {
					selListDomWidth += selListChilds[i].offsetWidth;
				}
				selListDom.style.width = selListDomWidth + 'px';
			}
		},
		data() {
			return {
				positionX: 0,
				currentValue: this.selects,
				show: this.value
			};
		},
		updated() {
			this.setSelListDomWidth();
		},
		mounted() {
			this.setSelListDomWidth();
		}
	};

</script>
<style lang='scss'>
	@import './style.scss';

</style>
